import Config from "./service/config";
import {createApp} from 'vue'
import App from './App.vue';

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import router from './router'
import {makeHash} from "vimmi-web-utils/cjs/makeHash";
import {localStore} from "vimmi-web-utils";

if (localStore.get('app_instance_token')) {
  Config.set('app_instance_token', localStore.get('app_instance_token'))
} else {
  let hash = makeHash(24);
  Config.set('app_instance_token', hash);
  localStore.set('app_instance_token', hash) // 1 year
}
let VueApp = createApp(App);

VueApp.use(router)
  .mount('#app')
